import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PersonalInfoDataForm.html?raw';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import DateInput from '../../../moreCore/UI/DateInput/DateInput';
import '../../../moreCore/UI/DateInput/DateInput';
import '../../../moreCore/UI/SelectBox/SelectBox';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import '../../../moreCore/UI/SearchSelect/SearchSelect';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

class PersonalInfoDataForm extends compose(_WidgetBaseSP) {
    templateString: any = template;
    isReadonly: boolean = false;
    isDirty: boolean = false;

    CitizenshipInput: MdsLax<InstanceType<typeof SearchSelect>>;
    FamilyStatusInput: MdsLax<InstanceType<typeof SearchSelect>>;
    PlaceOfBirthInput: MdsLax<InstanceType<typeof Edit>>;
    DateOfBirthInput: MdsLax<InstanceType<typeof DateInput>>;

    personalDataFormErrorContainer: HTMLElement;
    personalDataFormErrorMessage: HTMLElement;

    formData: IndividualData_PersonalInfoSave = {
        citizenship: "",
        family_status: "",
        day_of_birth: null,
        place_of_birth: "",
    };
    originalData: string = "";

    loadFormData(data: IndividualData_PersonalInfo): void {

        this.CitizenshipInput.loadListValues(data.citizenship.ID, true);
        this.FamilyStatusInput.loadListValues(data.family_status.ID, true);

        this.DateOfBirthInput.setValue(data.day_of_birth, true);
        this.PlaceOfBirthInput.setValue(data.place_of_birth, true);

        this.serializeFormData(data);

        this.originalData = JSON.stringify(this.formData);
        console.debug(this.originalData);
    }

    serializeFormData(data?: IndividualData_PersonalInfo): void {

        data ? this.formData.citizenship = data.citizenship.ID : this.formData.citizenship = this.CitizenshipInput.getValue();
        data ? this.formData.family_status = data.family_status.ID : this.formData.family_status = this.FamilyStatusInput.getValue();

        this.formData.day_of_birth = this.DateOfBirthInput.getValue();
        this.formData.place_of_birth = this.PlaceOfBirthInput.getValue();

        console.debug("SERIALIZE DATA:", this.formData);
        this.checkDirty();
        console.debug("isDirty:", this.isDirty);

        if (this.isValid()) this.showErrorMessage(false);
    }

    _onClick_saveBtn(): void {

        if (this.isValid()) {

            let requestUrl = window.appRoot + "IndividualDataSheet/SaveFormData";
            this.StandbyStart();

            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.formData),
                    sectionName: IndividualData_SectionName.PersonalInfo
                },
                lang.hitch(this, this._onSaveFormDataResponse),
                lang.hitch(this, this._onSaveFormDataError),
                false // sync
            );
        } else {

            this.showErrorMessage(true, this.translations["IndividualDataSheet_ContactData_DataNotValid"]);
        }
    }

    _onSaveFormDataResponse(): void {

        this.StandbyStop();

        let dlg = new GenericDialog();

        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");
        //this.UiModder.domClass.add(dlg.modalDlgContentNode, "w3-round");
        //this.UiModder.domStyle.set(dlg.textNode, "min-height", "150px");
        //this.UiModder.domClass.replace(dlg.headerBarNode, "mds-bg-orange", "secondaryBG");
        //this.UiModder.domClass.add(dlg.textNode, "w3-padding-64 w3-container w3-center");

        dlg.show(this.translations["FormDialog_Save_Message"], this.translations["FormDialog_Save_Header"], null, "fas fa-info-circle", "ok");

        this.emit("DataForm_close");
    }

    isValid(): boolean {

        if (this.CitizenshipInput.validateInput() === false) return false;
        if (this.FamilyStatusInput.validateInput() === false) return false;
        if (this.DateOfBirthInput.validateInput() === false) return false;
        if (this.PlaceOfBirthInput.validateInput() === false) return false;

        return true;
    }

    checkDirty(): void {

        this.isDirty = JSON.stringify(this.formData) !== this.originalData && this.originalData !== "";

        this.emit("change_isDirty", this.isDirty);
    }

    _onChangePersonalDataInput(): void {

        this.serializeFormData();
    }

    _onSaveFormDataError(err): void {

        this.StandbyStop();

        this.showErrorMessage(true, err.Message);
    }

    showErrorMessage(bool: boolean, msg?: string) {

        if (bool) {

            this.UiModder.domClass.remove(this.personalDataFormErrorContainer, "w3-hide");
            msg ? this.personalDataFormErrorMessage.innerHTML = msg : this.personalDataFormErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.personalDataFormErrorContainer, "w3-hide");
            this.personalDataFormErrorMessage.innerHTML = "";
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PersonalInfoDataForm);